import React from 'react'
import LuxPlusDestinationCarousel from './LuxPlusDestinationCarousel'
import LuxPlusLandingOfferCarousels from './LuxPlusLandingOfferCarousels'
import LuxPlusLandingFaqSection from './LuxPlusLandingFaqSection'
import LuxPlusLandingPartnerOffersSection from './LuxPlusLandingPartnerOffersSection'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

function LuxPlusLoggedInOffersTabSection() {
  return (<>
    <VerticalSpacer gap={40} />
    <LuxPlusDestinationCarousel />
    <LuxPlusLandingOfferCarousels />
    <LayoutContainer>
      <LuxPlusLandingPartnerOffersSection />
    </LayoutContainer>
    <LuxPlusLandingFaqSection />
  </>)
}

export default LuxPlusLoggedInOffersTabSection
